module.exports = __webpack_public_path__ + "static/media/18a-02_ST-2018-173x130cm-oleo-sobre-tela.caf58484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-02_ST-2018-173x130cm-oleo-sobre-tela.jpg
// module id = 220
// module chunks = 0